import { resolveEndpoint } from '../endpointUtils';

export default {
	getPaymentReasons: {
		uri: '/ibapi/v2/banks/:bankId/:scopeId/effectivewarning/paymentreasons?customersegment=:customerType',
		method: 'GET',
		x_bpi_version: '0.8.0',
		resolve(urlData) {
			return resolveEndpoint(this.uri, { ...urlData });
		},
	},
	createEWOutcome: {
		uri: '/ibapi/v2/banks/:bankId/:scopeId/effectivewarning',
		method: 'POST',
		x_bpi_version: '0.8.0',
		resolve(scopeId) {
			return resolveEndpoint(this.uri, { scopeId });
		},
	},
	createEWOutcomeStatic: {
		uri: '/ibapi/v2/banks/:bankId/:scopeId/effectivewarning/static',
		method: 'POST',
		x_bpi_version: '0.8.0',
		resolve(scopeId) {
			return resolveEndpoint(this.uri, { scopeId });
		},
	},
	generateRetrievalId: {
		uri: '/ibapi/v2/banks/:bankId/:scopeId/effectivewarning/generateretrievalid',
		method: 'POST',
		x_bpi_version: '0.8.0',
		resolve(scopeId) {
			return resolveEndpoint(this.uri, { scopeId });
		},
	},
	retrieveEWOutcome: {
		uri: '/ibapi/v2/banks/:bankId/:scopeId/effectivewarning/outcome?id=:effectiveWarningId&customerid=:customerId&ismultipleapproval=:isMultipleApproval&journey=:journey',
		method: 'GET',
		x_bpi_version: '0.8.0',
		resolve(urlData) {
			return resolveEndpoint(this.uri, { ...urlData });
		},
	},
	updateOutcomeAcknowledgement: {
		uri: '/ibapi/v2/banks/:bankId/:scopeId/effectivewarning/outcomeacknowledgement',

		method: 'POST',
		x_bpi_version: '0.8.0',
		resolve(scopeId) {
			return resolveEndpoint(this.uri, { scopeId });
		},
	},
	updateOutcomeAcknowledgementStatic: {
		uri: '/ibapi/v2/banks/:bankId/:scopeId/effectivewarning/static/outcomeacknowledgement',
		method: 'POST',
		x_bpi_version: '0.8.0',
		resolve(scopeId) {
			return resolveEndpoint(this.uri, { scopeId });
		},
	},
	updateAdditionalPaymentGuidance: {
		uri: '/ibapi/v2/banks/:bankId/:scopeId/effectivewarning/additionalpaymentguidance',
		method: 'POST',
		x_bpi_version: '0.8.0',
		resolve(scopeId) {
			return resolveEndpoint(this.uri, { scopeId });
		},
	},
	updateAdditionalPaymentGuidanceStatic: {
		uri: '/ibapi/v2/banks/:bankId/:scopeId/effectivewarning/static/additionalpaymentguidance',
		method: 'POST',
		x_bpi_version: '0.8.0',
		resolve(scopeId) {
			return resolveEndpoint(this.uri, { scopeId });
		},
	},
	cancelPayment: {
		uri: '/ibapi/v2/banks/:bankId/user/:scopeId/verification/:verificationId',
		x_bpi_version: '1.2.0',
		method: 'PUT',
		resolve(urlData) {
			return resolveEndpoint(this.uri, { ...urlData });
		},
	},
};
